import type { IconProps } from '@mote/ui/components/icon'
import { Icon } from '@mote/ui/components/icon'

export function BetaSvg(props: IconProps): JSX.Element {
  return (
    <Icon
      width='31'
      height='13'
      viewBox='0 0 31 13'
      fill='none'
      {...props}
      verticalAlign='initial'
      lineHeight='inherit'
    >
      <path fill='url(#a)' d='M0 4a4 4 0 0 1 4-4h27v9a4 4 0 0 1-4 4H0V4Z' />
      <path
        fill='#fff'
        d='M4.046 10V3h2.81c.727 0 1.28.17 1.66.51.387.333.58.763.58 1.29 0 .44-.12.793-.36 1.06-.233.26-.52.437-.86.53.4.08.73.28.99.6.26.313.39.68.39 1.1 0 .553-.2 1.01-.6 1.37-.4.36-.966.54-1.7.54h-2.91Zm1.28-4.06h1.34c.36 0 .637-.083.83-.25.194-.167.29-.403.29-.71 0-.293-.096-.523-.29-.69-.186-.173-.47-.26-.85-.26h-1.32v1.91Zm0 3.02h1.43c.38 0 .674-.087.88-.26.214-.18.32-.43.32-.75 0-.327-.11-.583-.33-.77-.22-.187-.516-.28-.89-.28h-1.41v2.06ZM10.355 10V3h4.57v1.03h-3.29v1.92h2.99v1h-2.99v2.02h3.29V10h-4.57Zm7.411 0V4.03h-2.04V3h5.37v1.03h-2.05V10h-1.28Zm3.086 0 2.56-7h1.44l2.56 7h-1.36l-.56-1.62h-2.73l-.57 1.62h-1.34Zm2.26-2.62h2.03l-1.02-2.91-1.01 2.91Z'
      />
      <defs>
        <linearGradient
          id='a'
          x1='-7.483'
          x2='9.162'
          y1='-2.321'
          y2='30.69'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#360AE8' />
          <stop offset='1' stopColor='#0AE8DB' />
        </linearGradient>
      </defs>
    </Icon>
  )
}
